// Generated by purs version 0.15.4
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var Probability = function (x) {
    return x;
};
var toNumber = function (v) {
    return v;
};
var showProbability = {
    show: function (v) {
        return "Probability(" + (show(v) + ")");
    }
};
var p999 = 0.999;
var p99 = 0.99;
var p95 = 0.95;
var p90 = 0.9;
var ordProbability = Data_Ord.ordNumber;
var mkProbability = function (p) {
    var $10 = p <= 1.0 && p >= 0.0;
    if ($10) {
        return new Data_Either.Right(p);
    };
    return new Data_Either.Left(p);
};
var eqProbability = Data_Eq.eqNumber;
var arbProbability = {
    arbitrary: /* #__PURE__ */ Data_Functor.map(Test_QuickCheck_Gen.functorGen)(Probability)(/* #__PURE__ */ Test_QuickCheck_Gen.choose(0.0)(1.0))
};
export {
    p90,
    p95,
    p99,
    p999,
    mkProbability,
    toNumber,
    eqProbability,
    ordProbability,
    showProbability,
    arbProbability
};
